<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Active Report</el-breadcrumb-item>
      <el-breadcrumb-item>AI Course Participation</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>


    <div class="container">
      <div style=" margin-right: 80px; "> </div>
      <div style=" margin-right: 80px; "> 过滤掉白名单用户 <el-switch v-model="switchFilter"></el-switch> </div>
      <div style="margin-bottom: 20px; margin-right: 20px; " size="medium"  >

        <el-radio-group v-model="cycle" style="margin-right: 20px; " size="medium">
          <el-radio-button label="daily">daily</el-radio-button>
          <el-radio-button label="weekly">weekly</el-radio-button>
          <el-radio-button label="monthly">monthly</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <h3 style="text-align: left;">AI Course Participation Chart    </h3>
    <div id="echart">由于运算量较大,请耐心等待一分钟左右</div>



    <h3 style="text-align: left;">AI Course Participation Table      <el-button type="primary" @click="exportCsv"   style="  margin-left: 75%; " >下载 CSV</el-button></h3>
    <el-table    :data="tableData" stripe style="width: 100%" empty-text="由于运算量较大,请耐心等待几十秒!"   
      :default-sort="{ prop: 'title', order: 'descending' }">

      <el-table-column prop="title" label="日期" width="180" sortable>
      </el-table-column>
      <el-table-column prop="userCount" label="用户数量"> </el-table-column>
      <el-table-column prop="userList" label="用户清单"   width="400"   > </el-table-column>
      <el-table-column prop="rhythmGameCount" label="RhythmGame活跃次数"> </el-table-column>
      <el-table-column prop="cyclingCount" label="Cycling活跃次数"> </el-table-column>
      <el-table-column prop="actionCount" label="总活跃次数"> </el-table-column>
      <el-table-column prop="avgAction" label="每用户次数" :formatter="formatDecimal"> </el-table-column>
      <el-table-column prop="totalDuration" label="总时长(Min)"> </el-table-column>
      <el-table-column prop="avgDuration" label="单次时长" :formatter="formatDecimal"> </el-table-column>
    </el-table>


  </div>
</template>

<script>

import { exportToCsv } from '@/utils/exportToCsv';

export default {
  data() {
    return {
      tableData: [],
      cycle: 'daily',
      switchFilter: true, // 过滤白名单
      
    }
  },
  // 在 Vue 实例或组件中定义过滤器
  //不知道为什么 现在还没法用, 持续看看吧
  filters: {
    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    }
  },

  created: function () {
    //注意回调函数的作用域!!!

  },
  watch: {

    cycle(newVal, oldVal) {
      this.getData()
    },
    switchFilter(newVal, oldVal) {
      this.getData()
    },

  },
  methods: {
    async getData() {

      this.tableData = []
      this.loading = true; // 开始加载
    // 发送请求时，添加 switchFilter 参数
    let res = await this.$http.get("/da/ai_course_participation/" + this.cycle, {
    params: {
      switchFilter: this.switchFilter // 传递开关参数
    }
  });
      this.tableData = res.data
      // console.log(res.data)
      //渲染图表
      this.getLoadEcharts();
    },
    exportCsv(){
      let  fileName  =   "AI Course Participation_"+ this.cycle+  "_Filter_"+ this.switchFilter 
      exportToCsv(this.tableData,fileName)
    },

    getLoadEcharts() {

      var chart = this.$echarts.init(
        document.getElementById("echart")
      );

      // 创建图表的配置项
      const options = {
        title: {
          text: 'AI Course Participation' // 添加标题
        },

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            },
          },

        },

        // 配置项的其他设置...
        xAxis: {
          // 设置横坐标轴的数据
          data: this.tableData.map(item => item.title)
        },
        yAxis: [
          {
            // 主Y轴（左侧）
            type: 'value',
            name: '',
            position: 'left',
            // 这里可以添加主Y轴的其他设置，例如axisLabel格式化等
          },
        ],
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        legend: {
          // 添加图例
          data: ['用户数量', 'Rhythm Game活跃次数', 'Cycling活跃次数', '总活跃次数', '平均活跃次数', '平均活跃时长']
        },
        series: [
          {
            name: '用户数量',
            type: 'line',
            data: this.tableData.map(item => item.userCount)
          },
          {
            name: 'Rhythm Game活跃次数',
            type: 'line',
            data: this.tableData.map(item => item.rhythmGameCount)
          },
          {
            name: 'Cycling活跃次数',
            type: 'line',
            data: this.tableData.map(item => item.cyclingCount)
          },
          {
            name: '总活跃次数',
            type: 'line',
            data: this.tableData.map(item => item.actionCount)
          },
          {
            name: '平均活跃次数',
            type: 'line',
            data: this.tableData.map(item => item.avgAction)
          },
          {
            name: '平均活跃时长',
            type: 'line',
            data: this.tableData.map(item => item.avgDuration)
          },

        ]
      };
      // 使用配置项显示图表
      chart.setOption(options);
    },

    formatDecimal(row, column, cellValue) {
      return cellValue ? parseFloat(cellValue).toFixed(2) : '0.00';
    },



  },




  mounted: function () {
    //注意回调函数的作用域!!!
    this.getData()
  }



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}

#echart {
  width: 95%;
  height: 450px;
  margin: auto;

}
</style>